module.exports = __webpack_public_path__ + "img/event_quest_list.c1475012.svg";